window.addEventListener('scroll', function () {
    const header = document.querySelector('.header-wrapper');

    if (window.scrollY > 0) {
        header.style.backgroundColor = '#FFF3E5';
    } else {
        header.style.backgroundColor = '';
    }

  
});


$(window).on('scroll', function() {
    if ($(this).scrollTop() > 50) {
        $('header').removeClass('header-top').addClass('header-fixed');
    } else {
        $('header').removeClass('header-fixed').addClass('header-top');
    }
});


$(document).ready(function() {
            $('.faq-question-new').click(function() {
                // 1. Find the parent container (.faq-item-new) of the clicked question
                var parentItem = $(this).closest('.faq-item-new');
                
                // 2. Find the answer inside that specific parent container
                var answer = parentItem.find('.faq-answer-new');
                
                // 3. Add .stop() before slideToggle to prevent the bouncing/looping bug
                answer.stop().slideToggle(300);
                
                // 4. Toggle 'faqactivenew' on the whole .faq-item-new wrapper
                parentItem.toggleClass('faqactivenew');

                // OPTIONAL: If you want only one answer open at a time, uncomment below:
                // $('.faq-answer-new').not(answer).stop().slideUp(300);
                // $('.faq-item-new').not(parentItem).removeClass('faqactivenew');
            });
            jQuery(".faq-container .faq-item-new:nth-child(2) .faq-question-new:first-child").click();



            jQuery("fieldset.custom-variant-fieldset label.custom-variant-row-label").each(function () {
    jQuery(this).find(".custom-variant-radio-element").on("click", function () {
        var val = jQuery(this).val().trim();

        if (val === "Small Sachet (1 serving)") {
            jQuery('li.thumbnail-list__item[data-variant-name="Vanilla / ' + val + '"]')
                .find("button")
                .click();
        }

        if (val === "Big Pouch (20 servings)") {
            jQuery('li.thumbnail-list__item[data-variant-name="Vanilla / ' + val + '"]:first-child')
                .find("button")
                .click();
        }
    });
});


        });



